import React from 'react';

import { Card, Empty, Steps, Tag } from 'antd';

import { AgroReportPhase } from '../../../models/AgroReport';

interface Props {
    phases: AgroReportPhase[];
}

const { Step } = Steps;

export default function PhaseTimeline(props: Props) {
    if (!props.phases || props.phases.length === 0) {
        return (
            <Card title="Фазы развития" style={{ marginBottom: 16 }}>
                <Empty description="Нет данных о фазах" />
            </Card>
        );
    }

    return (
        <Card title="Фазы развития" style={{ marginBottom: 16 }}>
            <Steps direction="vertical" size="small" current={-1}>
                {props.phases.map((p, i) => (
                    <Step
                        key={i}
                        status={p.start_date && p.end_date ? 'finish' : 'wait'}
                        title={
                            <span>
                                {p.name}
                                {p.critical && <Tag color="red" style={{ marginLeft: 8 }}>критическая</Tag>}
                            </span>
                        }
                        description={
                            p.start_date && p.end_date
                                ? `${p.start_date} — ${p.end_date}`
                                : 'нет данных за период'
                        }
                    />
                ))}
            </Steps>
        </Card>
    );
}
